"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetween = void 0;
const date_fns_1 = require("date-fns");
function isBetween(date, from, to, inclusivity = "()") {
    const isBeforeEqual = inclusivity.startsWith("[");
    const isAfterEqual = inclusivity[1] === "]";
    return ((isBeforeEqual
        ? (0, date_fns_1.isEqual)(from, date) || (0, date_fns_1.isBefore)(from, date)
        : (0, date_fns_1.isBefore)(from, date)) &&
        (isAfterEqual ? (0, date_fns_1.isEqual)(to, date) || (0, date_fns_1.isAfter)(to, date) : (0, date_fns_1.isAfter)(to, date)));
}
exports.isBetween = isBetween;
